"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ZPromoPrizeRewardSelect = exports.ZPromoCodeRecurringSelect = exports.ZPromoCodeInsert = exports.ZPromoCodeWithUsage = exports.ZPromoCodeSelect = exports.PromoRewardType = void 0;
const types_1 = require("@daymade/common-lib/types");
const zodSchemas_generated_1 = require("../generated/zodSchemas.generated");
const dbEnums_1 = require("@daymade/common-lib/dbEnums");
const dbJsonModels_1 = require("@daymade/common-lib/dbJsonModels");
const zod_1 = require("zod");
exports.PromoRewardType = dbEnums_1.RewardType;
const ZMonthlyUsage = zod_1.z.object({
    month: zod_1.z.coerce.date(),
    count: zod_1.z.number(),
});
exports.ZPromoCodeSelect = zodSchemas_generated_1.zodSelectPromoCode.extend((0, types_1.ensureSubsetOfKeys)(zodSchemas_generated_1.zodSelectPromoCode.shape, {
    createdAt: zod_1.z.coerce.date(),
    updatedAt: zod_1.z.coerce.date(),
    expiresAt: zod_1.z.coerce.date().nullable(),
    conditions: dbJsonModels_1.ZPromoConditions.partial().optional().nullable(),
}));
exports.ZPromoCodeWithUsage = exports.ZPromoCodeSelect.extend({
    usage: ZMonthlyUsage.array(),
});
exports.ZPromoCodeInsert = zodSchemas_generated_1.zodInsertPromoCode
    .pick({
    code: true,
    status: true,
    description: true,
    banner: true,
    promoType: true,
    action: true,
    rewardType: true,
    rewardValue: true,
    rewardCount: true,
})
    .extend((0, types_1.ensureSubsetOfKeys)(zodSchemas_generated_1.zodInsertPromoCode.shape, {
    allowMulti: zod_1.z.boolean().default(false),
    playerSpecific: zod_1.z.boolean().default(false),
    conditions: dbJsonModels_1.ZPromoConditions.partial().optional(),
    expiresAt: zod_1.z.coerce.date().optional().nullable(),
}));
exports.ZPromoCodeRecurringSelect = zodSchemas_generated_1.zodSelectPromoCodeRecurring
    .pick({
    id: true,
    status: true,
    createdAt: true,
    subscriptionId: true,
    remainingCount: true,
})
    .extend((0, types_1.ensureSubsetOfKeys)(zodSchemas_generated_1.zodInsertPromoCode.shape, {
    createdAt: zod_1.z.coerce.date(),
}));
exports.ZPromoPrizeRewardSelect = zodSchemas_generated_1.zodSelectPromoPrizeReward
    .pick({
    id: true,
    code: true,
    playerId: true,
    status: true,
    prizeId: true,
})
    .extend((0, types_1.ensureSubsetOfKeys)(zodSchemas_generated_1.zodSelectPromoPrizeReward.shape, {
    createdAt: zod_1.z.coerce.date(),
    expiresAt: zod_1.z.coerce.date().nullable(),
    chosenAt: zod_1.z.coerce.date().nullable(),
}));
//# sourceMappingURL=models.js.map